import { EntityState, StoreConfig } from '@datorama/akita';
import { Injectable, OnDestroy } from '@angular/core';
import { AbstractUiEntityStore } from 'projects/app-misc/src/app/modules/data/abstract-ui-entity.store';
import { ProjectActivityService } from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { TimeCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import { UserService } from 'projects/core/src/lib/login/data/user.service';

export interface TimeSheetsState extends EntityState<TimeCard, number> {
    timeCards: TimeCard[];
}

@Injectable({
    providedIn: 'root'
})
@StoreConfig({ name: 'timeSheets' })

export class TimeSheetsStore extends AbstractUiEntityStore<TimeSheetsState> {
    constructor() {
        super({
            timeCards: []
        });
    }

    updateCards(timeCards: TimeCard) {
        this.updateUi({
            timeCards
        })
    }
}